import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    const hash = location.hash
    if (hash) {
      const category = document.querySelector(`.catalog-list__item[data-id="${hash.replace('#', '')}"]`)
      if (category) {
        category.classList.add('catalog-list__item-active')
        document.querySelectorAll('.catalog-blocks .item').forEach(i => i.classList.remove('item-active'))
        document.querySelectorAll(`.catalog-blocks .item[data-category-id="${hash.replace('#', '')}"]`).forEach(i => i.classList.add('item-active'))   
      }

      const product = document.querySelector(`.catalog-blocks .item[data-id="${hash.replace('#', '')}"]`)
      if (product) {
        setTimeout(() => {
          product.click()
        }, 300)
      }   
    }
  }

}